import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザの同意事項情報を更新する
 *
 * @param {Number} uid ユーザID
 * @param {Object} optins 同意事項情報
 * @returns {Response} レスポンスデータ
 */
export function putUserOptins (uid, optins) {
  return request.put(`/users/${uid}/optins`, optins, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
